export default __webpack_public_path__ + "ec296fc.png";